import config from "../config/index";
import { traceSsr } from "./ssrTrace";
const globalData = {};
export function setGlobalData(key, val) {
  globalData[key] = val;
}
export function getGlobalData(key) {
  return globalData[key];
}

 
export const getMockUrl = ()=>{
  if(process.env.NODE_ENV!='development'){
    return ''
  }else{  
   // return "https://www.jiyunsir.com"
   // return "http://www.ws-express.com.cn"
    return `http://xjhy.mall-test.buyagent.omszt.com:8081`;
  }
}
export const getPrefixUrl = ()=>{
  if(typeof window!='undefined'){
    return `${window.location.origin}/api/cmsadmin`
  }else{  
    return `http://localhost:3000/api/cmsadmin`;
  }
}
export const  getProxyUrl  =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.collectionSite;
  }
 // return "https://www.jiyunsir.com/api"
// return "http://www.ws-express.com.cn/api"
 return "http://xjhy.m-shop-test.omszt.com:7888/api";
} 
export const getProxyMallAppUrl =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.mallSite;
  }
  return "http://api-test.jyshop.omszt.com:8081";
} 


export const getProxyShopAppUrl =()=>{
  
  if(process.env.NODE_ENV!='development'){
    return config.proxyLinks.shopSite
  }
  return "http://gateway.sztshop-test.omszt.com:7003";

}

export const getFrontServerAppUrl =()=>{
  const envFrontServerUrl = process.env.FRONT_SERVER_URL || process.env.NUXT_PUBLIC_FRONT_SERVER_URL;
  if(envFrontServerUrl){
    return envFrontServerUrl.replace(/\/+$/, "");
  }
  if(process.env.NODE_ENV=='development'){
    // Local dev should proxy to the reachable remote frontServer gateway path.
    return "http://mallstore.sztshop-test.omszt.com:7003/api/cmsadmin/frontServer"
  }
  return config.proxyLinks.frontServer
}

export const getQiankunSiteUrl = ()=>{
  // return "//xjhy.shopmember-test.omszt.com:7888";
 //  return "//localhost:8089";
  if(process.env.NODE_ENV!='development'){
    if(!process.client){
      return "//"+config.proxyLinks.qiankunSite;
    }else{
      
      return window.location.origin+ "/qiankun_app_wrap/"
    }
    
  }
  return process.client&& window.location.hostname.indexOf('localhost')>=0 ? `//${window.location.hostname}:8089`:"//xjhy.shopmember-test.omszt.com:7888";
}

 

export const mockJwtMap = {
  [getPrefixUrl()]: "",
};

export function checkMallFetchUrl(url) {
  return url.indexOf("mall=1") >= 0;
}

export function checkShopFetchUrl(url) {
  return url.indexOf("isShop=1") >= 0;
}


export function checkCollectionFetchUrl(url) {
    return url.indexOf("collection=1") >= 0;
  }
export function getToken() {
  return process.client&&window.localStorage.getItem(config.appTokenKey);
}

export function removeToken() {
  if (process.client) {
    window.localStorage.removeItem(config.appTokenKey);
    // remove cookie simultaneously
    const name = encodeURIComponent(config.appTokenKey);
    document.cookie = `${name}=; Max-Age=0; path=/`;
  }
}
export function setToken(val) {
  if (process.client) {
    window.localStorage.setItem(config.appTokenKey, val);
    // set cookie simultaneously (default 7 days)
    const name = encodeURIComponent(config.appTokenKey);
    const value = encodeURIComponent(val);
    const days = 7;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  }
}
export function getMallAppToken() {
  return process.client&&window.localStorage.getItem(config.mallAppTokenKey);
}

export function getCookieToken(headers) {
  if (process.server && headers && headers.cookie) {
    const cookies = headers.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    return cookies[config.appTokenKey];
  }
  return null;
}

export function setMallAppToken(val) {
  window.localStorage.setItem(config.appTokenKey, val);
}
export function removeMallAppToken(val) {
  window.localStorage.removeItem(config.appTokenKey, val);
}

export function setIsErpBuyMode(isErp) {
  
  if(process.client){
    if(isErp){
      window.sessionStorage.setItem('batchBindMallOrder','1');
      window.sessionStorage.setItem('batchBindMallOrder','1');
    }else{
      window.sessionStorage.removeItem('batchBindMallOrder');
    }
  }
}

export function isErpBuyMode() {
  if(process.client){
    return !!window.sessionStorage.getItem('batchBindMallOrder');
  }else{
    return false;
  }
 
}
 

function normalizeHost(value = "") {
  const normalizedValue = String(value || "").trim();
  if (!normalizedValue) {
    return "";
  }

  try {
    const url = new URL(/^https?:\/\//i.test(normalizedValue) ? normalizedValue : `http://${normalizedValue}`);
    return url.host;
  } catch (error) {
    return normalizedValue
      .replace(/^https?:\/\//i, "")
      .replace(/\/.*$/, "")
      .trim();
  }
}

function isLocalDebugHost(host = "") {
  const normalizedHost = normalizeHost(host).split(":")[0];
  return (
    normalizedHost === "localhost" ||
    normalizedHost === "127.0.0.1" ||
    normalizedHost === "::1" ||
    /^192\.168\./.test(normalizedHost) ||
    /^10\./.test(normalizedHost) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(normalizedHost)
  );
}

function getRedirectSubDomainFromRequest(requestUrl = "") {
  const normalizedRequestUrl = String(requestUrl || "").trim();
  if (!normalizedRequestUrl) {
    return "";
  }

  try {
    const url = new URL(normalizedRequestUrl, "http://localhost");
    return normalizeHost(url.searchParams.get("redirectSubDomain") || "");
  } catch (error) {
    return "";
  }
}

const REDIRECT_SUB_DOMAIN_QUERY_KEY = "redirectSubDomain";

function getClientStoredRedirectSubDomain() {
  if (!process.client || typeof window === "undefined") {
    return "";
  }

  const readStorageValue = (storage) => {
    try {
      return storage?.getItem(REDIRECT_SUB_DOMAIN_QUERY_KEY) || "";
    } catch (error) {
      return "";
    }
  };

  const redirectSubDomain =
    getRedirectSubDomainFromRequest(window.location.href)
    || readStorageValue(window.sessionStorage)
    || readStorageValue(window.localStorage);

  return normalizeHost(redirectSubDomain);
}

function getRedirectAwareCurrentServer({ headers, requestUrl, clientOrigin } = {}) {
  const host = process.server
    ? (headers && headers.host)
    : (typeof window !== "undefined" ? window.location.host : "");
  const origin = process.server
    ? (host ? `http://${host}` : "")
    : clientOrigin;

  if (!isLocalDebugHost(host || origin)) {
    return "";
  }

  const redirectSubDomain = process.server
    ? getRedirectSubDomainFromRequest(requestUrl)
    : getClientStoredRedirectSubDomain();

  if (!redirectSubDomain) {
    return "";
  }

  return `https://${redirectSubDomain}`;
}

export function getCurrentServer(headers, requestUrl = "") {
  const redirectAwareCurrentServer = getRedirectAwareCurrentServer({
    headers,
    requestUrl,
    clientOrigin: process.client && typeof window !== "undefined" ? window.location.origin : "",
  });

  const currentServer = process.server
    ? (redirectAwareCurrentServer || getMockUrl() || (headers && headers["x-custom-header1"]) || (headers && headers.host))
    : (redirectAwareCurrentServer || getMockUrl() || window.location.origin);

  traceSsr("getCurrentServer", {
    mockUrl: getMockUrl() || "",
    redirectAwareCurrentServer,
    requestUrl,
    host: headers && headers.host,
    xCustomHeader1: headers && headers["x-custom-header1"],
    xForwardedHost: headers && headers["x-forwarded-host"],
    xForwardedProto: headers && headers["x-forwarded-proto"],
    resolvedCurrentServer: currentServer,
  });

  return currentServer;
}

export function normalizeServerHost(server = "") {
  const normalizedServer = String(server || "").trim();
  if (!normalizedServer) {
    return "";
  }

  const normalizedWithoutTrailingSlash = normalizedServer.replace(/\/+$/, "");

  if (/^https?:\/\//i.test(normalizedWithoutTrailingSlash)) {
    try {
      return new URL(normalizedWithoutTrailingSlash).host;
    } catch (error) {
      return normalizedWithoutTrailingSlash
        .replace(/^https?:\/\//i, "")
        .split("/")[0]
        .trim();
    }
  }

  return normalizedWithoutTrailingSlash.split("/")[0].trim();
}

export function getCurrentServerKey(server = "") {
  return normalizeServerHost(server) || "default";
}

export function getOpenAccessTokenKey(server = "") {
  return `openaccessjwt_${getCurrentServerKey(server)}`;
}
 
 
export const localeTo1688CountryMap = {
  "ja_JP":'jp',
  // "zh-CN":'zh',
  // "zh-TW":'zh',
  "en":'en',
  "vi_VN":'vi',
  "ja_JP":'ja',
};

 
export const isTarget_Blank = function () {
  if(process.client && isErpBuyMode() ){
      return "_self";
  }
  return "_blank"
};

export function getSafeLink(link) {
  const safeLink = String(link || "").trim();
  if (!safeLink) {
    return "";
  }
  if (/^(javascript|data):/i.test(safeLink)) {
    return "";
  }
  return appendRedirectSubDomainToInternalLink(safeLink);
}

export function isHttpLink(link) {
  return getSafeLink(link).indexOf("http") === 0;
}
export default globalData;

function appendRedirectSubDomainToInternalLink(link) {
  if (!process.client || typeof window === "undefined") {
    return link;
  }

  const redirectSubDomain = getClientStoredRedirectSubDomain();
  if (!redirectSubDomain || link.startsWith("#")) {
    return link;
  }

  if (/^\/\//.test(link) || (/^[a-z][a-z\d+.-]*:/i.test(link) && !/^https?:/i.test(link))) {
    return link;
  }

  try {
    const currentOrigin = window.location.origin;
    const parsedUrl = new URL(link, currentOrigin);

    if (parsedUrl.origin !== currentOrigin || parsedUrl.searchParams.get(REDIRECT_SUB_DOMAIN_QUERY_KEY)) {
      return link;
    }

    parsedUrl.searchParams.set(REDIRECT_SUB_DOMAIN_QUERY_KEY, redirectSubDomain);

    if (/^https?:/i.test(link)) {
      return parsedUrl.toString();
    }

    return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
  } catch (error) {
    return link;
  }
}
